import { useState } from "react";
import randomUUID from "../utils/randomUUID";
const EXPERIMENT_SEED_KEY = "experimentSeed";
const getStoredSeed = () => {
  try {
    let storedExperimentSeed = localStorage.getItem(EXPERIMENT_SEED_KEY);
    if (!storedExperimentSeed) {
      storedExperimentSeed = randomUUID();
      localStorage.setItem(EXPERIMENT_SEED_KEY, storedExperimentSeed);
    }
    return storedExperimentSeed;
  } catch {
    return randomUUID();
  }
};
const useExperimentSeed = () => {
  const [experimentSeed] = useState(getStoredSeed);
  return experimentSeed;
};
export default useExperimentSeed;